import React from 'react'

import {Steps, Button} from 'antd'
import {useHistory} from 'react-router'

interface Props {
  current: number
}
const RetrieveSteps: React.FC<Props> = ({current}) => {
  const {Step} = Steps
  const history = useHistory()
  const backToLogin = () => {
    history.push('/login')
  }
  return (
    <>
      <div className="backToLogin">
        <Button type="link" onClick={backToLogin}>
          回到登录页
        </Button>
      </div>
      <div className="title bold text-center" style={{marginBottom: 32}}>
        忘记密码
      </div>

      <Steps current={current} style={{marginBottom: 32}}>
        <Step title="确认账号"></Step>
        <Step title="重置密码" />
      </Steps>
    </>
  )
}

export default RetrieveSteps
